'use strict';
module.exports = require('./ToggleButton.vue');